<div class="image-dialog container">
    <div class="row">
        <h2 mat-dialog-title>HRA Security Images</h2>
        <div mat-dialog-content>
                <mat-selection-list (selectionChange)="addSelection($event)">
                    <mat-list-option class="col-lg-2 horizontal-list" [value]="image" *ngFor="let image of securityImageList">
                        <img src="{{image}}" alt="">
                    </mat-list-option>
                </mat-selection-list>
        </div>
    </div>
    <mat-action-list mat-dialog-actions class="row">
        <div class="col-12 text-right">
            <button mat-raised-button class="security-image-dialog-button" color="warn" (click)="onNoClick()">Cancel</button>
            <button mat-raised-button class="security-image-dialog-button" [mat-dialog-close]="data.method" color="primary" cdkfocusinitial>Save</button>
        </div>
    </mat-action-list>
</div>
